import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import React from "react"
import { HeartIcon } from "@heroicons/react/outline"

import BookBar from "../boat/BookBar"
export default function TemplateHeader({
  name,
  length,
  capacity,
  image,
  fullWidth,
  imgSrc,
  link,
}) {
  return (
    <div className="container mx-auto px-2 lg:px-8 h-auto grid grid-cols-12">
      <div
        className={
          fullWidth
            ? "col-span-12 grid gap-4 xl:gap-0"
            : "col-span-12 xl:col-span-9 grid gap-4 xl:gap-0"
        }
      >
        <div className="row-start-1 col-start-1 relative z-0">
          <GatsbyImage
            image={image}
            alt={name}
            className="h-[85vh] lg:h-[80vh] object-cover w-full"
          />
        </div>
        <div className="col-start-1 row-start-1 relative z-10 h-[85vh] lg:h-[80vh] bg-black bg-opacity-50 grid items-stretch">
          <div className="flex justify-between items-start pl-[50px] pt-[50px] pr-[40px] pb-[40px] self-start">
            <h1 className="text-white">{name}</h1>
            {/* <div>
              <button className="w-10 h-10 lg:w-20 lg:h-20 rounded-full bg-white flex items-center justify-center">
                <HeartIcon className="h-5 w-5 lg:h-10 lg:w-10 text-black" />
              </button>
            </div> */}
          </div>
          <BookBar imgSrc={imgSrc} link={link} name={name} />
        </div>
      </div>
      {!fullWidth && (
        <div className="col-span-12 xl:col-span-3 ">
          <div className="flex space-x-5 xl:space-x-0 xl:grid xl:gap-4 justify-items-end item-stretch">
            <div className="p-4 bg-gray-100 text-center grid gap-4 w-full xl:w-5/6 ml-auto">
              <StaticImage
                src="../../../static/img/resize-length 1.svg"
                alt="length"
                className="mx-auto"
              />
              <p className="font-property text-xs">Length</p>
              <strong className="text-xl">{length}</strong>
            </div>
            <div className="p-4 bg-gray-100 text-center grid gap-4 w-full xl:w-5/6 ml-auto">
              <StaticImage
                src="../../../static/img/multiple-users-silhouette 1.svg"
                alt="length"
                className="mx-auto"
              />
              <p className="font-property text-xs">Capacity</p>
              <strong className="text-xl">{capacity}</strong>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
